import React from 'react';
import { useTranslation } from 'react-i18next';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';
import BalancesMenuContainer from '@alphapoint/apex-web/lib/components/BalancesMenu/BalanceMenuContainer';
import WalletDetailsContainer from '@alphapoint/apex-web/lib/components/WalletDetails/WalletDetailsContainer';
import TransfersContainer from '@alphapoint/apex-web/lib/components/Transfers/TransfersContainer';
import TransfersFiltersContainer from '@alphapoint/apex-web/lib/components/Transfers/TransfersFilters';
import RecentActivityWithFilterContainer from '@alphapoint/apex-web/lib/components/RecentActivityWithFilter';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './ProductDetailsPage.css';
import AccountsDropdownContainer from '@alphapoint/apex-web/lib/components/AccountsDropdown/AccountsDropdownContainer';

const layoutClasses = getBEMClasses('product-details-page');

const ProductDetailsPage = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={layoutClasses('container')}>
        <div className={layoutClasses('menu')}>
          <AccountsDropdownContainer customClass="page-activity" showSelectedAccount={true} />
          <BalancesMenuContainer />
        </div>
        <div className={layoutClasses('content')}>
          <div className={layoutClasses('wallet-details')}>
            <WalletDetailsContainer />
          </div>
          <div className={layoutClasses('transfers')}>
            <div className={layoutClasses('transfers-header')}>{t('Transfers')}</div>
            <TransfersFiltersContainer />
            <TransfersContainer />
          </div>
          <RecentActivityWithFilterContainer filterForSelected={true} />
        </div>
      </div>
      <PageFooterLayout />
    </React.Fragment>
  );
};

export default withAuthentication(ProductDetailsPage);
